import market from "../modules/market";
import search from '../modules/search';
import headcolumtab from '../modules/header';


headcolumtab.init(); //头部栏目标签配置

market();  //全球股市相关

search();  //search模块初始化







